import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import Carousel from '../../components/Carousel';
import DefaultCard from '../../components/DefaultCard';
import FingerTipsLinks from '../../components/FingertipsLinks/FingertipsLinks';
import {
  HwDcDashboardProvider,
  HwDcDashboardStore,
} from '../../providers/hwDcDashboard';
import {
  HEALTH_INSURANCE_ROUTH,
  HEALTH_SUMMARY,
  LIFE_EVENTS_ROUTE,
  PROFILE_ROUTE,
} from '../../routes/types';
import HealthSavingsAndSpending from '../widgets/dashboards/HealthSavingsAndSpending';
import HealthSnapshot from '../widgets/dashboards/HealthSnapshot';
import OtherCompanyBenefits from '../widgets/dashboards/OtherCompanyBenefits';
import SavingsSnapshot from '../widgets/dashboards/SavingsSnapshot';
import TotalRewardsHalf from '../widgets/dashboards/TotalRewardsHalf';

const dataCompanyContributions = {
  grid: {
    padding: {
      left: 0,
    },
  },
  legend: {
    show: false,
  },

  dataLabels: {
    enabled: false,
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        grid: {
          padding: {
            left: 0,
          },
        },
        legend: {
          show: false,
        },
        title: {},
      },
    },
  ],
  colors: ['#074CBC', '#F48462', '#07B4A0', '#EEA968', '#92E3A9'],
  series: [95072, 15905, 14791, 6500, 0],
  labels: [
    'Compensation',
    'Health and Welfare',
    'Retirement',
    'Equity',
    'Other Benefits',
  ],

  tooltip: {
    enabled: false,
  },

  plotOptions: {
    pie: {
      donut: {
        labels: {
          show: true,
          name: {
            offsetY: 10,
          },
          total: {
            show: true,
            showAlways: true,
            fontSize: '18px',
            fontFamily: 'Roboto, Arial, sans-serif',
            fontWeight: 500,
            label: `$132,268`,
            formatter: function (a: any) {
              return '';
            },
          },
        },
      },
    },
  },
};

const linksData = [
  {
    linkHeader: 'More Details',
    route: `${HEALTH_SUMMARY}`,
  },

  {
    linkHeader: 'Change Coverage',
    route: `${LIFE_EVENTS_ROUTE}`,
  },

  {
    linkHeader: 'Beneficiaries',
    route: `${PROFILE_ROUTE.slice(0, 9)}beneficiaries`,
  },

  {
    linkHeader: 'Family Members',
    route: `${PROFILE_ROUTE.slice(0, 9)}familymembers`,
  },
];

const NewHireDashboardView = () => {
  const { fingertipLinks, companiesMessages, otherCompanyBenefits } =
    useContext(HwDcDashboardStore) || {};
  const navigate = useNavigate();

  return (
    <Container className={'cnd-custom-container-large mb-12 px-lg-9 px-xl-0'}>
      <Row>
        <Col className="mt-7 mt-lg-11 col-12 col-lg-7">
          <DefaultCard
            className="h-100 flex-column flex-sm-row "
            variant="blue-motif"
            leftHeading={
              <div className="text-sm-20-lg-32">Welcome to Benefits!</div>
            }
            leftSubheading={
              <div className="text-sm-12-lg-14 fw-light mb-7">
                We're happy to introduce you to the benefits that are available.
              </div>
            }
            button={
              <Button
                className="align-self-end"
                variant="primary-shadow"
                size="sm"
                onClick={() => navigate(HEALTH_INSURANCE_ROUTH)}
              >
                Enroll Now
              </Button>
            }
          />
        </Col>
        <Col className="mt-7 mt-lg-11 col-12 col-lg-5">
          <DefaultCard
            className="flex-column"
            variant="blue"
            leftHeading={<div className="text-sm-20-lg-32">Current Events</div>}
            leftSubheading={
              <Container className="p-0 mb-7">
                <Row className="text-sm-12-lg-14 p-0">
                  <Col className=" text-nowrap col-12 fw-light">
                    There are currently no events.
                  </Col>
                </Row>
              </Container>
            }
          />
        </Col>
      </Row>

      <Row className="m-0 d-flex justify-content-between">
        <Col className="m-0 p-0 mt-7 mt-lg-11 col-12 col-lg-7 pe-lg-4">
          <SavingsSnapshot />
        </Col>
        <Col className="m-0 p-0 mt-7 mt-lg-11 col-12 col-lg-5 ps-lg-6">
          <FingerTipsLinks data={fingertipLinks} />
        </Col>
      </Row>

      <Row className="m-0 d-flex justify-content-between">
        <Col
          className={
            'm-0 p-0 d-flex flex-column pt-lg-6 col-12 col-lg-6 mt-10 mt-lg-6 pe-lg-4'
          }
        >
          <HealthSnapshot transperant linksData={linksData} />
        </Col>
        <Col
          className={
            'm-0 p-0 d-flex flex-column pt-lg-6 col-12 col-lg-6 mt-10 mt-lg-6 ps-lg-6'
          }
        >
          <HealthSavingsAndSpending />
        </Col>
      </Row>

      <Row className="m-0 d-flex justify-content-between">
        <Col
          className={
            'm-0 p-0 d-flex flex-column pt-lg-6 col-12 col-lg-6 mt-10 mt-lg-6 pe-lg-4'
          }
        >
          <TotalRewardsHalf
            dataCompanyContributions={dataCompanyContributions}
          />
        </Col>
        <Col
          className={
            'm-0 p-0 d-flex flex-column pt-lg-6 col-12 col-lg-6 mt-10 mt-lg-6 ps-lg-4'
          }
        >
          <OtherCompanyBenefits
            companyBenefits={otherCompanyBenefits}
          />
        </Col>
      </Row>

      <Row className="m-0 mt-12 p-0">
        <Carousel data={companiesMessages} />
      </Row>
    </Container>
  );
};

const NewHireDashboard = () => {
  return (
    <HwDcDashboardProvider>
      <NewHireDashboardView />;
    </HwDcDashboardProvider>
  );
};

export default NewHireDashboard;
